import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { DataLabel } from "../components/common";
import { EnvelopeSimple, CheckCircle, XCircle, Warning, PaperPlaneTilt } from "@phosphor-icons/react";

const KIND_LABEL = { immediate: "Contenu prêt", digest: "Récap quotidien", cycle_alert: "Alerte cycle", reminder: "Rappel",
  test: "Test", weekly_report: "Résumé hebdo", review_report: "Révision trimestrielle",
  publish_confirmation: "Confirmation publication", status_report: "Rapport de situation" };

export default function EmailHistory() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => {
    load(); const t = setInterval(load, 10000); return () => clearInterval(t);
  }, []);

  const sendWeekly = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/notifications/weekly-report");
      if (data?.status === "sent") toast.success("Résumé hebdomadaire envoyé");
      else if (data?.status === "skipped") toast.info("Aucune activité cette semaine — rien à envoyer");
      else if (data?.status === "no_key") toast.error("Clé Resend manquante");
      else toast.info("Envoi traité");
      setTimeout(load, 800);
    } catch (e) { toast.error("Envoi impossible"); } finally { setBusy(false); }
  };

  const icon = (s) => s === "sent" ? <CheckCircle weight="fill" className="text-emerald-600" size={16} />
    : s === "no_key" || s === "no_recipient" ? <Warning weight="fill" className="text-amber-500" size={16} />
    : <XCircle weight="fill" className="text-red-500" size={16} />;
  const statusLabel = { sent: "Envoyé", no_key: "Clé manquante", no_recipient: "Sans destinataire", error: "Erreur" };

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-muted-foreground mb-1">Traçabilité</div>
          <h1 className="font-serif text-4xl text-brand tracking-tight">Historique des e-mails</h1>
        </div>
        <button data-testid="send-weekly-report-btn" onClick={sendWeekly} disabled={busy}
          className="flex items-center gap-2 border border-brand text-brand hover:bg-brand-soft px-4 py-2 rounded-md text-sm font-medium transition-colors disabled:opacity-60">
          <PaperPlaneTilt size={16} /> Envoyer le résumé hebdo maintenant
        </button>
      </div>
      <div className="bg-white border border-border rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary text-left text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
            <tr><th className="px-4 py-3">Type</th><th className="px-4 py-3">Sujet</th><th className="px-4 py-3">Destinataire</th><th className="px-4 py-3">Statut</th><th className="px-4 py-3">Date</th></tr>
          </thead>
          <tbody className="divide-y divide-border">
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground"><EnvelopeSimple size={26} className="mx-auto mb-2" />Aucun e-mail envoyé pour l'instant.</td></tr>}
            {items.map((n) => (
              <tr key={n.id} data-testid={`email-row-${n.id}`} className="hover:bg-secondary/40 transition-colors">
                <td className="px-4 py-3 text-xs">{KIND_LABEL[n.kind] || n.kind}</td>
                <td className="px-4 py-3 max-w-md truncate">{n.subject}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{n.to}</td>
                <td className="px-4 py-3"><span className="flex items-center gap-1.5 text-xs">{icon(n.status)} {statusLabel[n.status] || n.status}</span></td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(n.created_at).toLocaleString("fr-FR")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
